import { ApplicationConfig } from '@config/application.config';

export default {
  namespace: ApplicationConfig.applicationName,
  key: [
    'auth.token',
    'auth.loggedUser',
    'application.language'
  ]
};